/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentCoverage } from "./ShipmentCoverage";
import {
  ShipmentCoverageFromJSON,
  ShipmentCoverageFromJSONTyped,
  ShipmentCoverageToJSON,
  ShipmentCoverageToJSONTyped,
} from "./ShipmentCoverage";
import type { CustomerSpecificCarrierCoverage } from "./CustomerSpecificCarrierCoverage";
import {
  CustomerSpecificCarrierCoverageFromJSON,
  CustomerSpecificCarrierCoverageFromJSONTyped,
  CustomerSpecificCarrierCoverageToJSON,
  CustomerSpecificCarrierCoverageToJSONTyped,
} from "./CustomerSpecificCarrierCoverage";

/**
 *
 * @export
 * @interface CustomerSpecificCoverageResult
 */
export interface CustomerSpecificCoverageResult {
  /**
   *
   * @type {number}
   * @memberof CustomerSpecificCoverageResult
   */
  shipmentCount: number;
  /**
   *
   * @type {Array<ShipmentCoverage>}
   * @memberof CustomerSpecificCoverageResult
   */
  ignoredShipments: Array<ShipmentCoverage>;
  /**
   *
   * @type {Array<CustomerSpecificCarrierCoverage>}
   * @memberof CustomerSpecificCoverageResult
   */
  carrierCoverageResult: Array<CustomerSpecificCarrierCoverage>;
}

/**
 * Check if a given object implements the CustomerSpecificCoverageResult interface.
 */
export function instanceOfCustomerSpecificCoverageResult(
  value: object,
): value is CustomerSpecificCoverageResult {
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  if (!("ignoredShipments" in value) || value["ignoredShipments"] === undefined)
    return false;
  if (
    !("carrierCoverageResult" in value) ||
    value["carrierCoverageResult"] === undefined
  )
    return false;
  return true;
}

export function CustomerSpecificCoverageResultFromJSON(
  json: any,
): CustomerSpecificCoverageResult {
  return CustomerSpecificCoverageResultFromJSONTyped(json, false);
}

export function CustomerSpecificCoverageResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificCoverageResult {
  if (json == null) {
    return json;
  }
  return {
    shipmentCount: json["shipmentCount"],
    ignoredShipments: (json["ignoredShipments"] as Array<any>).map(
      ShipmentCoverageFromJSON,
    ),
    carrierCoverageResult: (json["carrierCoverageResult"] as Array<any>).map(
      CustomerSpecificCarrierCoverageFromJSON,
    ),
  };
}

export function CustomerSpecificCoverageResultToJSON(
  json: any,
): CustomerSpecificCoverageResult {
  return CustomerSpecificCoverageResultToJSONTyped(json, false);
}

export function CustomerSpecificCoverageResultToJSONTyped(
  value?: CustomerSpecificCoverageResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentCount: value["shipmentCount"],
    ignoredShipments: (value["ignoredShipments"] as Array<any>).map(
      ShipmentCoverageToJSON,
    ),
    carrierCoverageResult: (value["carrierCoverageResult"] as Array<any>).map(
      CustomerSpecificCarrierCoverageToJSON,
    ),
  };
}
